/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: "false" | "true" }} Motor_Encoder_IncidentInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "Incident with motor encoder" |
* | "true" | "Incident with motor encoder since {date}" |
*
* @param {Motor_Encoder_IncidentInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const motor_encoder_incident = /** @type {((inputs: Motor_Encoder_IncidentInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Motor_Encoder_IncidentInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Incident with motor encoder`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Incident with motor encoder since ${i?.date}`);
		return /** @type {LocalizedString} */ ("motor_encoder_incident");
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Incident avec l'encodeur du moteur`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Incident avec l'encodeur du moteur depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ ("motor_encoder_incident");
	}
});